<template>
  <picture v-if="result" class="def-picture">
    <source :srcset="loadImage ? result?.desktop?.src : undefined" media="(min-width: 992px)" />
    <source :srcset="loadImage ? result?.tablet?.src : undefined" media="(min-width: 768px)" />

    <img
      v-if="loadImage"
      :src="result?.mobile?.src"
      :alt="result?.mobile?.alt"
      :width="width"
      :height="height"
      decoding="async"
      :loading="priority ? 'eager' : 'lazy'"
      :fetchpriority="priority ? 'high' : 'auto'"
      class="def-picture__image"
    />
  </picture>
</template>

<script>
import useDeviceInfo from '@use/useDeviceInfo';

export default {
  name: 'DefPicture',

  props: {
    result: Object,
    maxWidth: String,
    maxHeight: String,
    priority: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      intersectionObserver: null,
      options: {
        rootMargin: '100px',
        threshold: 0.01,
      },
      loadImage: false,
      deviceScreen: useDeviceInfo().screen,

      maxW: this.maxWidth ?? '100%',
      maxH: this.maxHeight ?? '100%',
    };
  },
  computed: {
    getPicture() {
      return this.result?.[this.deviceScreen] ?? this.result;
    },
    width() {
      return this.getPicture?.width;
    },
    height() {
      return this.getPicture?.height;
    },
  },

  watch: {
    maxWidth() {
      this.maxW = this.maxWidth ?? '100%';
    },

    maxHeight() {
      this.maxH = this.maxHeight ?? '100%';
    },
  },

  mounted() {
    try {
      if (this.priority) {
        this.loadImage = true;
      } else if (this.result && !this.intersectionObserver) {
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);

          this.intersectionObserver.observe(this.$el);
        } else {
          this.loadImage = true;
        }
      }
    } catch (err) {
      console.error(err);
    }
  },
  beforeUnmount() {
    try {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    observerCallBack(entries) {
      try {
        if (entries[0].intersectionRatio <= 0) return;

        this.loadImage = true;

        this.intersectionObserver?.unobserve(this.$el);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-picture {
  display: block;

  aspect-ratio: v-bind(width) / v-bind(height);

  max-width: v-bind(maxW);
  max-height: v-bind(maxH);

  overflow: hidden;

  &__image {
    display: block;

    width: 100%;
    height: 100%;

    object-fit: contain;
    color: transparent;
  }
}
</style>
